import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import type AssistantViewController from '../../AssistantView/AssistantViewController';

const createToolToggleReasoning = (
  assistantController: AssistantViewController
) => {
  class ToolToggleReasoning extends Tool {
    static toolName = 'Enhanced reasoning';
    static iconClass = 'fa-regular fa-brain-circuit fa-fw';

    static action(toolArgs: ToolArgsWithController): void {
      assistantController.actionToggleReasoning();
    }

    static available(toolArgs: ToolArgsWithController): boolean {
      return true;
    }

    static isEnabled(toolArgs: ToolArgsWithController): boolean {
      return true;
    }
  }

  return ToolToggleReasoning;
};

export default createToolToggleReasoning;
